var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagItaly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0-4.3-2.713-7.966-6.521-9.379v18.756C19.287 19.964 22 16.3 22 12z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 4.3 2.714 7.965 6.522 9.378V2.622A10.004 10.004 0 002 12z",
    fill: "#6DA544"
  })));
}
export default SvgFlagItaly;